<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'categories.subtitle' | t }}</p>
    </div>
    <div class="toolbar-actions">
      @if (hasDirtyOrder()) {
        <button class="ct-btn ct-btn-primary" type="button" (click)="saveOrder()">
          {{ 'categories.saveOrder' | t }}
        </button>
      }
      <button class="ct-btn ct-btn-primary" type="button" (click)="openCreate(null)">
        {{ 'categories.new' | t }}
      </button>
    </div>
  </div>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th class="order-col">{{ 'categories.order' | t }}</th>
          <th class="col-image">{{ 'categories.image' | t }}</th>
          <th>{{ 'common.name' | t }}</th>
          <th>{{ 'common.slug' | t }}</th>
          <th>{{ 'common.parent' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr><td colspan="7">{{ 'common.loading' | t }}</td></tr>
        } @else if (flat().length === 0) {
          <tr><td colspan="7">{{ 'categories.empty' | t }}</td></tr>
        } @else {
          @for (item of flat(); track item.id) {
            <tr [class.row-parent]="item.level === 0" [class.row-child]="item.level === 1">
              <td class="order-col">
                <div class="order-btns">
                  <button
                    type="button"
                    class="order-btn"
                    [disabled]="item.siblingIndex === 0"
                    (click)="move(item, -1)"
                    [attr.aria-label]="'categories.moveUp' | t"
                    [attr.title]="'categories.moveUp' | t"
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    class="order-btn"
                    [disabled]="item.siblingIndex === item.siblingCount - 1"
                    (click)="move(item, 1)"
                    [attr.aria-label]="'categories.moveDown' | t"
                    [attr.title]="'categories.moveDown' | t"
                  >
                    ↓
                  </button>
                </div>
              </td>
              <td class="col-image">
                @if (item.imageUrl) {
                  <img class="image-thumb" [src]="item.imageUrl" [alt]="item.name" appImgFallback />
                } @else {
                  <span class="image-empty">—</span>
                }
              </td>
              <td class="name-col">
                <div class="name-col__inner">
                  @if (item.level === 1) {
                    <span class="name-col__branch" aria-hidden="true"></span>
                  }
                  <span class="name-col__text">{{ item.name }}</span>
                </div>
              </td>
              <td class="slug-col">{{ item.slug }}</td>
              <td class="parent-col">{{ item.parentName ?? '—' }}</td>
              <td class="col-status status-col">
                <span class="ct-badge" [class.ct-badge-success]="item.isActive" [class.ct-badge-muted]="!item.isActive">
                  {{ (item.isActive ? 'common.active' : 'common.inactive') | t }}
                </span>
              </td>
              <td class="actions">
                <div class="actions__row">
                  <span class="actions__slot">
                    @if (item.level === 0) {
                      <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openCreate(item.id)">
                        {{ 'categories.addChild' | t }}
                      </button>
                    }
                  </span>
                  <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(item)">
                    {{ 'common.edit' | t }}
                  </button>
                  <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="remove(item)">
                    {{ 'common.delete' | t }}
                  </button>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</section>

@if (dialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDialog()">
    <div class="ct-dialog wide" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingId() ? 'categories.edit' : 'categories.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="name">{{ 'common.name' | t }}</label>
            <input id="name" class="ct-input" formControlName="name" (input)="onNameChange($any($event.target).value)" />
          </div>
          <div class="ct-field">
            <label for="slug">{{ 'common.slug' | t }}</label>
            <input id="slug" class="ct-input" formControlName="slug" />
          </div>
          <div class="ct-field">
            <label for="parentId">{{ 'common.parent' | t }}</label>
            <select id="parentId" class="ct-select" formControlName="parentId">
              <option [ngValue]="null">{{ 'common.noneRoot' | t }}</option>
              @for (parent of parentOptions(); track parent.id) {
                <option [ngValue]="parent.id">{{ parent.name }}</option>
              }
            </select>
          </div>
          <div class="ct-field">
            <label>{{ 'categories.image' | t }} <span class="optional">{{ 'categories.imageOptional' | t }}</span></label>
            <p class="hint">{{ 'categories.imageHint' | t }}</p>
            @if (imagePreview()) {
              <img class="image-preview" [src]="imagePreview()!" alt="" />
            }
            <div class="file-picker">
              <input
                #imageInput
                class="file-input"
                type="file"
                accept="image/jpeg,image/png,image/webp,image/gif,image/svg+xml"
                (change)="onImageSelected($event)"
              />
              <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="imageInput.click()">
                <span class="material-symbols-outlined">image</span>
                {{ 'categories.chooseImage' | t }}
              </button>
              @if (imagePreview()) {
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="clearImage()">
                  {{ 'categories.removeImage' | t }}
                </button>
              }
            </div>
          </div>
          <div class="ct-field">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>
        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
